module.exports = __webpack_public_path__ + "fonts/GeogrotesqueCyr-SemiBold.6a3846dc.ttf";